import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import HelpUiPage from "./HelpUiPage";

type props = {
  open: boolean;
  handleClose: () => void;
  handleSave: (
    pageData: { title: string; content: string },
    isEditing: boolean,
  ) => void;
  initialDoc?: { title: string; content: string } | null;
};

const HelpDocumentDialog: React.FC<props> = ({
  open,
  handleClose,
  handleSave,
  initialDoc,
}) => {
  return (
    <Dialog open={open} onOpenChange={handleClose} modal={false}>
      <div
        className={
          "w-full h-full bg-modalBackground top-0 left-0 z-modal-level-3 " +
          (open ? "fixed" : "hidden")
        }
      ></div>

      <DialogContent
        className="sm:max-w-[55vw] max-h-[90vh] overflow-auto"
        onInteractOutside={(event) => {
          event.preventDefault();
        }}
      >
        <DialogHeader>
          <DialogTitle className="border-b pb-2">Help Document</DialogTitle>
          <HelpUiPage handleSave={handleSave} initialDoc={initialDoc} />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default HelpDocumentDialog;
